import { Box, type BoxProps } from '@mantine/core'
import { type PropsWithChildren } from 'react'

import styles from './styles.module.css'

export function SectionTable({
  children,
  ...props
}: PropsWithChildren<BoxProps>) {
  return <Box {...props}>{children}</Box>
}

function Header({ children }: PropsWithChildren<BoxProps>) {
  return <Box className={styles.sectionTableHeader}>{children}</Box>
}

function Body({ children }: PropsWithChildren<BoxProps>) {
  return <Box className={styles.sectionTableBody} size='md'>{children}</Box>
}

function Footer({ children }: PropsWithChildren<BoxProps>) {
  return <Box className={styles.sectionTableFooter}>{children}</Box>
}

SectionTable.Header = Header
SectionTable.Body = Body
SectionTable.Footer = Footer
